import { ref } from 'vue';

const currentActiveMessageId = ref<string | null>(null);

export const useGlobalMentionCard = (messageId: string) => {
  const isActive = () => currentActiveMessageId.value === messageId;

  const activate = () => {
    currentActiveMessageId.value = messageId;
  };

  const deactivate = () => {
    if (currentActiveMessageId.value === messageId) {
      currentActiveMessageId.value = null;
    }
  };

  const deactivateAll = () => {
    currentActiveMessageId.value = null;
  };

  return {
    isActive,
    activate,
    deactivate,
    deactivateAll,
  };
};
